(ns frontend.view.printouts.events
  (:require [frontend.conn :as conn]
            [frontend.db :as app-db]
            [frontend.logging :as logging]
            [frontend.view.printouts.db :as db]
            [frontend.routing :as routing]
            [promesa.core :as p]))

(defn fetch-data! []
  (conn/send! :report/reports-page
              {:token      (:token @db/settings)
               :report     (:report @db/settings)
               :start-date (:start-date @db/settings)
               :end-date   (:end-date @db/settings)}
              (fn [{:keys [body]}]
                (swap! app-db/app-state assoc-in [:views :printouts :data] body)
                true)))

(defn change! [k v]
  (swap! db/settings assoc k v)
  (fetch-data!))

(defn print! [_]
  (swap! db/settings assoc :printing true)
  (-> (conn/sendp! :report/reports-print
                   {:report     (:report @db/settings)
                    :token      (:token @db/settings)
                    :start-date (:start-date @db/settings)
                    :end-date   (:end-date @db/settings)}
                   60000)
      (p/then (fn [resp]
                (let [body (:body resp)
                      url (:download-url body)
                      w (when url (.open js/window "about:blank" "_blank"))]
                  (when w
                    (aset w "location" (:download-url body)))
                  (swap! db/settings dissoc :printing))))
      (p/catch (fn [e]
                 (logging/log "REPORT ERROR : " e)
                 (swap! db/settings dissoc :printing)
                 ))))
